export default "__VITE_ASSET__670dff95__"